// extracted by mini-css-extract-plugin
module.exports = {"label":"PosSwitchClinicPicker_label__2Cmz4"};